import { render, staticRenderFns } from "./QuestionTypeSelector.vue?vue&type=template&id=28c2ee19&scoped=true"
import script from "./QuestionTypeSelector.vue?vue&type=script&lang=ts"
export * from "./QuestionTypeSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c2ee19",
  null
  
)

export default component.exports